// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qYiBoRKHcb9rrwmjTfa2 {
  height: 40px;
}

.XGvY6VnH4QAiIAAbYrMx span {
  color: var(--primary600) !important;
}

.XGvY6VnH4QAiIAAbYrMx svg path {
  fill: var(--primary600) !important;
}

.XGvY6VnH4QAiIAAbYrMx {
  border: 2px solid var(--primary600) !important;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/widen-library/admin/src/components/FilterBox/FilterBox.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8CAA8C;AAChD","sourcesContent":[".filter-button {\n  height: 40px;\n}\n\n.filter-button-active span {\n  color: var(--primary600) !important;\n}\n\n.filter-button-active svg path {\n  fill: var(--primary600) !important;\n}\n\n.filter-button-active {\n  border: 2px solid var(--primary600) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filter-button": `qYiBoRKHcb9rrwmjTfa2`,
	"filter-button-active": `XGvY6VnH4QAiIAAbYrMx`
};
export default ___CSS_LOADER_EXPORT___;
